export default __webpack_public_path__ + "static/media/refresh-purple.65cc5536.svg";